export default __webpack_public_path__ + "9e1b857a9a9780981e046e55706fa5f3.svg";